import {ref, watch} from "vue";
import { useReportingStore } from "@/store/reporting";

export function useMetricTile<T>(reportKey: string) {
  const metric = ref<T>(null);
  const loading = ref(false);
  const reportingStore = useReportingStore();
  async function fetchData() {
    loading.value = true;
    metric.value = await reportingStore.fetchReport(reportKey);
    loading.value = false;
  }

  watch(
    () => reportingStore.refreshKey,
    async () => {
      if (reportingStore.active) {
        await fetchData();
      } else {
        metric.value = null;
      }
    },
    { immediate: true } // so it loads on first mount too
  );

  return {
    metric,
    loading,
    fetchData
  };
}
